<!--
  @author xiehan
  @description 数据查询
  @date 2018/11/26
-->
<template>
  <div class="dataSearch__content">
    <el-button 
      type="primary" 
      v-text="$t('common.add')" 
      @click="jump2add"
      v-g-rac="gRac('dataSearch@add')"></el-button>
    <el-button 
      type="primary" 
      v-text="$t('dataSearch.searchHistory')"
      @click="jump2History"
      v-g-rac="gRac('dataSearch@checkHistory')"></el-button>
    <div class="mt-base">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="0" input-width="auto">
        <el-form-item>
          <el-input v-model="searchForm.name"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button 
              type="primary" 
              v-text="$t('common.search')"
              @click="searchEvent"
              v-g-rac="gRac('dataSearch@search')"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-for="item in dataList"
      class="each-data"
      @click="chooseData(item)"
      :title="item.name"
      :key="item.id">
      <img :src="dataImg">
      <div v-text="item.name"></div>
    </div>
    <div v-show="dataList.length === 0" v-text="$t('common.noData')" class="no-data"></div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dataSearchBiz from '@/logic/logRetrieve/dataSearchBiz'
  export default {
    mixins: [rac],
    data () {
      return {
        searchForm: {
          name: ''
        },
        primaryList: [],
        dataList: [],
        dataImg: require('@/assets/image/cmdb/resorce.png')
      }
    },
    components: {},
    methods: {
      searchEvent () {
        this.dataList = this.primaryList
          .filter(item => item.name.indexOf(this.searchForm.name) > -1)
      },
      search () {
        dataSearchBiz.queryConditionByName().then(data => {
          this.primaryList = data
          this.dataList = data
        })
      },
      jump2History () {
        this.$router.push({ name: 'dataSearchHistory' })
      },
      jump2add () {
        this.$router.push({ name: 'handlerSearchConfig' })
      },
      chooseData (info) {
        this.$router.push({ name: 'dataSearchCheck', query: { id: info.id } })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dataSearch' &&
          (from.name === 'dataSearchCheck' || from.name === 'handlerSearchConfig')) {
          this.searchForm.name = ''
          this.search()
        }
      }
    },
    mounted () {
      this.search()
    }
  }
</script>

<style scoped>
  .each-data {
    width: auto;
    display: inline-block;
    position: relative;
    text-align: center;
    padding: 10px;
    cursor: pointer;
  }
  .each-data:hover img {
    position: relative;
    top: -1px;
    left: -1px;
  }
  .no-data {
    text-align: center;
    margin-top: 20px;
  }
</style>